export const QUICK_RESERVATION_SEARCH = "quick-reservation";
export const QUICK_RESERVATION_SEARCH_PER_ROOM = `${QUICK_RESERVATION_SEARCH}/per-room`;
